import type { ITargetPest } from './typings'

export function pestNamesToIds(
  allTargetPests: ITargetPest[],
  names: null | string[],
): string[] {
  if (!names || names.length === 0) return []

  return allTargetPests.reduce<string[]>((found, pest) => {
    const { id, name } = pest

    if (names.includes(name)) return [...found, id]
    return found
  }, [])
}
